window.StickerCovenConfigurator =
  window.StickerCovenConfigurator || {};

window.StickerCovenConfigurator.ConfiguratorUI =
  class ConfiguratorUI {
    constructor(section, form) {
      this.section = section;
      this.form = form;

      this.currency =
        section.dataset.currency || "USD";

      this.locale =
        section.dataset.locale || "en-US";

      this.elements = {
        width: form.querySelector(
          '[data-option="width"]'
        ),

        height: form.querySelector(
          '[data-option="height"]'
        ),

        customQuantity: form.querySelector(
          "[data-custom-quantity]"
        ),

        popularSizes: Array.from(
          form.querySelectorAll(
            "[data-popular-size]"
          )
        ),

        price: section.querySelector(
          "[data-configurator-price]"
        ),

        unitPrice: section.querySelector(
          "[data-unit-price]"
        ),

        pricingError: section.querySelector(
          "[data-pricing-error]"
        ),

        addToCart: section.querySelector(
          "[data-add-to-cart]"
        ),

        cartStatus: section.querySelector(
          "[data-cart-status]"
        ),

        specialInstructions: form.querySelector(
          "[data-special-instructions]"
        ),

        imageSharingConsent: form.querySelector(
          "[data-image-sharing-consent]"
        ),

        instagramHandle: form.querySelector(
          "[data-instagram-handle]"
        ),

        threadsHandle: form.querySelector(
          "[data-threads-handle]"
        ),

        calculatedPriceProperty:
          form.querySelector(
            "[data-calculated-price-property]"
          ),

        areaProperty: form.querySelector(
          "[data-area-property]"
        ),

        areaRateProperty: form.querySelector(
          "[data-area-rate-property]"
        ),

        volumeRateProperty:
          form.querySelector(
            "[data-volume-rate-property]"
          ),
        turnaroundMessage: section.querySelector(
        "[data-turnaround-message]"
          )
      };

      this.summary = {
        shape: section.querySelector(
          "[data-summary-shape]"
        ),

        size: section.querySelector(
          "[data-summary-size]"
        ),

        finish: section.querySelector(
          "[data-summary-finish]"
        ),

        material: section.querySelector(
          "[data-summary-material]"
        ),

        whiteInk: section.querySelector(
          "[data-summary-white-ink]"
        ),
        border: section.querySelector(
          "[data-summary-border]"
        ),

        easyPeel: section.querySelector(
          "[data-summary-easy-peel]"
        ),

        quantity: section.querySelector(
          "[data-summary-quantity]"
        ),

        whiteInk: section.querySelector(
          "[data-summary-white-ink]")
      };
    }

    updateSummary(state) {
      const width =
        this.formatMeasurement(state.width);

      const height =
        this.formatMeasurement(state.height);

      if (this.summary.shape) {
        this.summary.shape.textContent =
          state.shape || "—";
      }

      if (this.summary.size) {
        this.summary.size.textContent =
          width && height
            ? `${width} × ${height} in`
            : "—";
      }

      if (this.summary.finish) {
        this.summary.finish.textContent =
          state.finish || "—";
      }

      if (this.summary.material) {
        this.summary.material.textContent =
          state.material || "—";
      }

      if (this.summary.whiteInk) {
        this.summary.whiteInk.textContent =
          state.whiteInk || "—";
      }

      if (this.summary.border) {
        this.summary.border.textContent =
          state.border || "—";
      }

      if (this.summary.easyPeel) {
        this.summary.easyPeel.textContent =
          state.easyPeel || "—";
      }

      if (this.summary.quantity) {
        this.summary.quantity.textContent =
          state.quantity || "—";
      }

      if (this.summary.whiteInk) {
        this.summary.whiteInk.textContent =
          state.whiteInk || "—";
      }
      
    }

    updatePrice(pricing) {
      this.hidePricingError();

      if (this.elements.price) {
        this.elements.price.textContent =
          this.formatMoney(
            pricing.totalPrice
          );
      }

      if (this.elements.unitPrice) {
        this.elements.unitPrice.textContent =
          this.formatMoney(
            pricing.unitPrice,
            4
          );
      }

      this.updatePricingProperties(pricing);
    }

    showInvalidPrice(message) {
      if (this.elements.price) {
        this.elements.price.textContent = "—";
      }

      if (this.elements.unitPrice) {
        this.elements.unitPrice.textContent =
          "—";
      }

      this.clearPricingProperties();
      this.showPricingError(message);
    }

    updatePricingProperties(pricing) {
      const elements = this.elements;

      if (elements.calculatedPriceProperty) {
        elements.calculatedPriceProperty.value =
          pricing.totalPrice.toFixed(2);
      }

      if (elements.areaProperty) {
        elements.areaProperty.value =
          pricing.area.toFixed(4);
      }

      if (elements.areaRateProperty) {
        elements.areaRateProperty.value =
          pricing.areaRate.toFixed(2);
      }

      if (elements.volumeRateProperty) {
        elements.volumeRateProperty.value =
          pricing.volumeRate.toFixed(2);
      }
    }

    clearPricingProperties() {
      [
        this.elements.calculatedPriceProperty,
        this.elements.areaProperty,
        this.elements.areaRateProperty,
        this.elements.volumeRateProperty
      ].forEach((input) => {
        if (input) {
          input.value = "";
        }
      });
    }

    setActivePopularSize(activeButton) {
      this.elements.popularSizes.forEach(
        (button) => {
          const isActive =
            button === activeButton;

          button.classList.toggle(
            "is-active",
            isActive
          );

          button.setAttribute(
            "aria-pressed",
            String(isActive)
          );
        }
      );
    }

    syncPopularSizeState(width, height) {
      this.elements.popularSizes.forEach(
        (button) => {
          const buttonWidth =
            Number.parseFloat(
              button.dataset.width
            );

          const buttonHeight =
            Number.parseFloat(
              button.dataset.height
            );

          const isMatch =
            Number.isFinite(width) &&
            Number.isFinite(height) &&
            Math.abs(
              width - buttonWidth
            ) < 0.001 &&
            Math.abs(
              height - buttonHeight
            ) < 0.001;

          button.classList.toggle(
            "is-active",
            isMatch
          );

          button.setAttribute(
            "aria-pressed",
            String(isMatch)
          );
        }
      );
    }

    setAddToCartEnabled(enabled) {
      if (!this.elements.addToCart) return;

      this.elements.addToCart.disabled =
        !enabled;
    }

    setAddToCartLoading(isLoading) {
      const button =
        this.elements.addToCart;

      if (!button) return;

      if (isLoading) {
        button.dataset.originalText =
          button.textContent.trim();

        button.textContent = "Adding…";
        button.disabled = true;
        return;
      }

      button.textContent =
        button.dataset.originalText ||
        "Add to Cart";

      delete button.dataset.originalText;
    }

    showPricingError(message) {
      const element =
        this.elements.pricingError;

      if (!element) return;

      element.textContent = message;
      element.hidden = false;
    }

    hidePricingError() {
      const element =
        this.elements.pricingError;

      if (!element) return;

      element.textContent = "";
      element.hidden = true;
    }

    showCartStatus(
      message,
      isError = false
    ) {
      const element =
        this.elements.cartStatus;

      if (!element) return;

      element.textContent = message;
      element.hidden = false;

      element.classList.toggle(
        "is-error",
        isError
      );
    }

    clearCartStatus() {
      const element =
        this.elements.cartStatus;

      if (!element) return;

      element.textContent = "";
      element.hidden = true;

      element.classList.remove(
        "is-error"
      );
    }

    formatMeasurement(value) {
      const number =
        Number.parseFloat(value);

      if (!Number.isFinite(number)) {
        return "";
      }

      return Number.isInteger(number)
        ? String(number)
        : number
            .toFixed(2)
            .replace(/0+$/, "")
            .replace(/\.$/, "");
    }

    updateTurnaround(quantity) {
      if (!this.elements.turnaroundMessage) {
        return;
      }

      let message =
        "Ready in 3 business days";

      if (quantity >= 7500) {
        message =
          "Ready in 7 business days";
      } else if (quantity >= 5000) {
        message =
          "Ready in 5 business days";
      } else if (quantity >= 2500) {
        message =
          "Ready in 4 business days";
      }

      this.elements.turnaroundMessage.textContent =
        `✓ ${message}`;
    }

    formatMoney(
      amount,
      maximumFractionDigits = 2
    ) {
      try {
        return new Intl.NumberFormat(
          this.locale,
          {
            style: "currency",
            currency: this.currency,
            minimumFractionDigits: 2,
            maximumFractionDigits
          }
        ).format(amount);
      } catch (error) {
        return `$${amount.toFixed(2)}`;
      }
    }
  };